import type { FieldErrors } from "react-hook-form";

const RHF_LEAF_KEYS = new Set(["ref", "type", "types", "root"]);

function hasAnyErrorInSubtree(node: unknown): boolean {
  if (node == null) return false;
  if (typeof node !== "object") return false;

  const obj = node as Record<string, unknown>;

  if (typeof obj.message === "string" && obj.message.length > 0) {
    return true;
  }

  if (Array.isArray(node)) {
    for (const item of node) {
      if (hasAnyErrorInSubtree(item)) return true;
    }
    return false;
  }

  for (const key of Object.keys(obj)) {
    if (RHF_LEAF_KEYS.has(key)) continue;
    if (hasAnyErrorInSubtree(obj[key])) return true;
  }
  return false;
}

export function errorTreeHasPath(
  errors: FieldErrors | undefined | null,
  fieldKey: string,
): boolean {
  if (!errors || !fieldKey) return false;

  const segments = fieldKey.split(".");
  let node: unknown = errors;

  for (const segment of segments) {
    if (node == null || typeof node !== "object") return false;
    node = (node as Record<string, unknown>)[segment];
  }

  return hasAnyErrorInSubtree(node);
}

export function errorTreeHasAnyPath(
  errors: FieldErrors | undefined | null,
  fieldKeys: readonly string[] | undefined,
): boolean {
  if (!errors || !fieldKeys?.length) return false;
  for (const key of fieldKeys) {
    if (errorTreeHasPath(errors, key)) return true;
  }
  return false;
}
